import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { API_URL_COMPANIES } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';
import { SkeepersConnector } from './shared/skeepers-connector.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LinkShortenerService {
  constructor(
    private httpClient: HttpClient,
    private alcmeonContextService: AlcmeonContextService,
    private errorHandlingService: ErrorHandlingService
  ) {}

  getLinks(siteId) {
    return this.httpClient.get(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/sites/${siteId}/links`);
  }

  getSkeepersConnector(): Observable<SkeepersConnector> {
    return this.httpClient
      .get<SkeepersConnector>(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/links/encryption_keys`)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  updateLinks(siteId, config) {
    return this.httpClient
      .put(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/sites/${siteId}/links`, config)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  updateConnector(body: SkeepersConnector) {
    return this.httpClient
      .put(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/links/encryption_keys`, body)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }
}
